var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 34,
    width: 116,
    height: 116,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1642_5095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.2279 140.24C120.373 140.24 140.758 119.855 140.758 94.62C140.758 69.3853 120.373 49 95.2279 49C70.083 49 49.6976 69.3853 49.6976 94.62C49.6976 119.855 70.083 140.24 95.2279 140.24Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2279 140.24C120.373 140.24 140.758 119.855 140.758 94.62C140.758 69.3853 120.373 49 95.2279 49C70.083 49 49.6976 69.3853 49.6976 94.62C49.6976 119.855 70.083 140.24 95.2279 140.24Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.967 75.8512C148.001 75.8512 149.649 74.2027 149.649 72.1692C149.649 70.1358 148.001 68.4873 145.967 68.4873C143.934 68.4873 142.285 70.1358 142.285 72.1692C142.285 74.2027 143.934 75.8512 145.967 75.8512Z",
    fill: "#F1F3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.356 61.3929C152.744 61.3929 153.87 60.2671 153.87 58.8784C153.87 57.4897 152.744 56.3639 151.356 56.3639C149.967 56.3639 148.841 57.4897 148.841 58.8784C148.841 60.2671 149.967 61.3929 151.356 61.3929Z",
    fill: "#F1F3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6445 78.4555C48.0332 78.4555 49.159 77.3297 49.159 75.941C49.159 74.5523 48.0332 73.4265 46.6445 73.4265C45.2558 73.4265 44.13 74.5523 44.13 75.941C44.13 77.3297 45.2558 78.4555 46.6445 78.4555Z",
    fill: "#F1F3F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3143 133.146C53.8933 133.146 55.9841 131.055 55.9841 128.476C55.9841 125.897 53.8933 123.806 51.3143 123.806C48.7353 123.806 46.6445 125.897 46.6445 128.476C46.6445 131.055 48.7353 133.146 51.3143 133.146Z",
    fill: "#F1F3F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.706 125.478H57.6229C52.9938 125.478 49.3143 121.798 49.3143 117.169V73.3712C49.3143 68.7421 52.9938 65.0626 57.6229 65.0626H133.706C138.335 65.0626 142.014 68.7421 142.014 73.3712V117.169C142.014 121.798 138.335 125.478 133.706 125.478Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8165 111.828H60.7098C59.6415 111.828 58.8107 110.997 58.8107 109.929C58.8107 108.861 59.6415 108.03 60.7098 108.03H72.8165C73.8848 108.03 74.7157 108.861 74.7157 109.929C74.7157 110.997 73.8848 111.828 72.8165 111.828Z",
    fill: "#D6DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3997 111.828H80.2929C79.2247 111.828 78.3938 110.997 78.3938 109.929C78.3938 108.861 79.2247 108.03 80.2929 108.03H92.3997C93.4679 108.03 94.2988 108.861 94.2988 109.929C94.2988 110.997 93.4679 111.828 92.3997 111.828Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.985 111.828H99.8786C98.8103 111.828 97.9795 110.997 97.9795 109.929C97.9795 108.861 98.8103 108.03 99.8786 108.03H111.985C113.054 108.03 113.884 108.861 113.884 109.929C113.884 110.997 113.054 111.828 111.985 111.828Z",
    fill: "#D6DCE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.569 111.828H119.463C118.394 111.828 117.564 110.997 117.564 109.929C117.564 108.861 118.394 108.03 119.463 108.03H131.569C132.638 108.03 133.469 108.861 133.469 109.929C133.469 110.997 132.638 111.828 131.569 111.828Z",
    fill: "#D6DCE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.178 89.0388C131.112 89.0388 134.3 85.8503 134.3 81.9172C134.3 77.984 131.112 74.7955 127.178 74.7955C123.245 74.7955 120.057 77.984 120.057 81.9172C120.057 85.8503 123.245 89.0388 127.178 89.0388Z",
    fill: "#AAB2C5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.8 89.0388C121.734 89.0388 124.922 85.8503 124.922 81.9172C124.922 77.984 121.734 74.7955 117.8 74.7955C113.867 74.7955 110.679 77.984 110.679 81.9172C110.679 85.8503 113.867 89.0388 117.8 89.0388Z",
    fill: "#D6DCE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8848 91.294H60.5911C59.6415 91.294 58.8107 90.4631 58.8107 89.5135V80.9676C58.8107 80.018 59.6415 79.1872 60.5911 79.1872H73.7661C74.7157 79.1872 75.5465 80.018 75.5465 80.9676V89.5135C75.6652 90.4631 74.8343 91.294 73.8848 91.294Z",
    fill: "#D6DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1642_5095",
    x: 0.697632,
    y: 0,
    width: 189.06,
    height: 189.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0 0.619608 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1642_5095"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.403922 0 0 0 0 0.431373 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1642_5095",
    result: "effect2_dropShadow_1642_5095"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1642_5095",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCard);
export default __webpack_public_path__ + "static/media/EmptyCard.6f0db7fce14b7c50a703174d1870864e.svg";
export { ForwardRef as ReactComponent };